// a v-combobox keeps typed or pasted text as a plain string; map it back to the
// item whose key matches, so a full metering point number or ECID selects the entry
export function resolveComboboxItem(selection, items, keys) {
  if (typeof selection !== 'string') return selection;
  const query = selection.replace(/\s/g, '').toUpperCase();
  if (!query) return null;
  const match = (items || []).find(item =>
    keys.some(key => String(item[key] ?? '').replace(/\s/g, '').toUpperCase() === query));
  return match ?? selection;
}

// true once the combobox holds an item and not just typed text
export function isComboboxItem(selection) {
  return !!selection && typeof selection === 'object';
}
